import { z } from 'zod';

export const SeatLevelDisplaySchema = z.object({
  enabled: z.boolean(),
});
